var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4003_89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60C46.5685 60 60 46.5685 60 30Z",
    fill: "#EB5E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0542 29.8287C26.0542 27.6907 25.9122 25.5397 26.0922 23.4147C26.2892 21.0627 27.8432 20.3257 29.8102 21.6627C32.8292 23.7107 35.7592 25.8997 38.6592 28.1157C40.2022 29.2927 40.1932 30.6947 38.6232 31.8737C35.6332 34.1197 32.6362 36.3627 29.5492 38.4737C27.8802 39.6147 26.3202 38.8567 26.1432 36.7797C25.9432 34.4797 26.0982 32.1497 26.0982 29.8337H26.0532L26.0542 29.8287Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4003_89"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.e789c723ffaa494339462eb8b69dd01e.svg";
export { ForwardRef as ReactComponent };